import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseLocalRepository } from '@data/base/base-local.repository';
import { Observable } from 'rxjs';
import { ApiResources } from '@constants/api-resources';

@Injectable()
export class GetApiSecundariaRepository extends BaseLocalRepository {
  constructor(httpClient: HttpClient) {
    super(httpClient, ApiResources.GET_API_SECUNDARIAS);
  }

  getApiSecundariaId(): Observable<any> {
    return this.getRequest<any>({ limit: 30 });
  }
}
